// ─── Session Key Helpers ────────────────────────────────────
// Composite keys for per-account bot session storage.
// Each Spotware account gets its own independent bot configuration.
//
// Key format: {strategyId}::account::{accountId}
// Example: "abc-123::account::43582903"
//
// Uses "::account::" as separator to avoid SQL LIKE wildcard issues
// (underscore "_" is a single-char wildcard in SQL LIKE).

export function buildSessionKey(strategyId: string, accountId: string): string {
  return `${strategyId}::account::${accountId}`;
}

export function parseSessionKey(key: string): { strategyId: string; accountId: string } | null {
  const match = key.match(/^(.+)::account::(.+)$/);
  if (!match) return null;
  return { strategyId: match[1], accountId: match[2] };
}

/**
 * Build a Supabase LIKE pattern to match all sessions for a given strategy
 * across all accounts.
 * Example: "abc-123::account::%"
 */
export function buildSessionPrefix(strategyId: string): string {
  return `${strategyId}::account::%`;
}